import Select from "react-select";
import React, {useCallback} from "react";
import { useTranslation } from 'react-i18next';

export function CustomSelect(props) {
    const { t } = useTranslation();

    const customFilter = useCallback((searchByFunction) => (candidate, input) => {
        if (!searchByFunction) {
            return false;
        }

        if (input) {

            const searchByValue = searchByFunction(candidate.value);
            return searchByValue.includes(input);
        }
        return true;
    }, []);

    return <Select
        {...props}
        classNamePrefix={props.classNamePrefix + " custom-select"}
        noOptionsMessage={() => t("common.not_found")}
        theme={(theme) => ({
            ...theme,
            borderRadius: 0,
            colors: {
                ...theme.colors,
                primary: '#dce3f9',
            },
        })}
        filterOption={customFilter(props.searchBy)}

    />;
}